import React from 'react';
import { action, observable } from 'mobx';
import { observer } from 'mobx-react';
import { ReactComponent as ErrorIcon } from 'Assets/svg/new_icons/errorTriangle.svg';
import CommonErrorPopup from './commonErrorPopup';

class WarningPopupState {
  @observable showPopup = false;

  defaultPopupValue = {
    title: '',
    message: '',
    className: '',
    callback: () => {},
    Icon: ErrorIcon,
  };

  @observable popupValues = this.defaultPopupValue;

  @action
  setShowPopup = data => {
    this.popupValues = {
      title: data.title,
      message: data.message,
      className: data.className,
      callback: data.callback || this.defaultPopupValue.callback,
      ...(data.Icon && { Icon: data.Icon }),
    };
    this.showPopup = true;
  };
}

const warningPopupState = new WarningPopupState();

const CommonWarningPopup = observer(() => {
  return warningPopupState.showPopup ? (
    <CommonErrorPopup
      className={warningPopupState.popupValues.className}
      title={warningPopupState.popupValues.title}
      message={warningPopupState.popupValues.message}
      Icon={warningPopupState.popupValues.Icon}
      togglePopup={type => {
        if (type === 'buttonClick') warningPopupState.popupValues.callback();
        warningPopupState.showPopup = false;
      }}
    />
  ) : null;
});

export { warningPopupState };
export default CommonWarningPopup;
